<style>
</style>

<template>
    <div class="goal-selection">
        <div class="row img-row">
            <div 
                v-for="(section, idx) in sectionResults" 
                :key="section.id"
                class="col-3 img-col" 
                @click="selectedSectionIdx = idx"
            >
                <div class="img-parent bpsection" style="display: inline-block;" :class="{selected: (selectedSectionIdx == idx)}">
                    <div class="img-gray img-wrapper-green">
                        <img :src="$basePath+'/images/tiny/'+section.page.metadata.image_tiny_gray" :alt="section.section.name" :title="section.section.name">
                    </div>
                    <div class="img-color img-wrapper-green">
                        <img :src="$basePath+'/images/tiny/'+section.page.metadata.image_tiny_gray" :alt="section.section.name" :title="section.section.name">
                    </div>
                    <div class="img-title text-center mt-1">
                        &nbsp;
                        <span class="title-text">
                            <small>{{section.section.name}}</small>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        
        <ul class="nav nav-tabs nav-fill">
            <li class="nav-item has-not-met"><a class="nav-link active" data-toggle="tab" href="#toggleUnmet">Evidence-based Practices Your Program Has Not Met</a></li>
            <li class="nav-item has-met"><a class="nav-link" data-toggle="tab" href="#toggleMet">Evidence-based Practices Your Program Has Met</a></li>
        </ul>

        <div class="tab-content bp-tabs">
            <!-- ******************** -->
            <!-- UNMET Evidence-based Practices -->
            <!-- ******************** -->
            <div id="toggleUnmet" class="collapse content dark t2 tab-pane show active fade" role="tabpanel" :aria-labelledby="'unmet_'+selectedSection.name+'-tab'">
                <div class="has-not-met-pane table-responsive">
                    <div class="faux-bottom-border" style="height: 10px; background-color: #dc6a2f;">&nbsp;</div>
                    <table class="table">
                        <tbody>
                            <template v-if="unmetGoals.length > 0">
                                <template v-if="closeGoals.length > 0">
                                    <tr>
                                        <td class="ap-table-subhead" colspan="2">Close to meeting</td>
                                    </tr>
                                    <goal-option 
                                        v-for="goal in closeGoals"
                                        :key="goal.id"
                                        :goal="goal"
                                        :action-plans="allActionPlans"
                                        v-on:goalSelected="createNewActionPlan"
                                    ></goal-option>
                                </template>
                                <template v-if="notCloseGoals.length > 0">
                                    <tr>
                                        <td class="ap-table-subhead" colspan="2">More Room For Improvement</td>
                                    </tr>
                                    <goal-option 
                                        v-for="goal in notCloseGoals"
                                        :key="goal.id"
                                        :goal="goal"
                                        :action-plans="allActionPlans"
                                        v-on:goalSelected="createNewActionPlan"
                                    ></goal-option>
                                </template>
                            </template>
                            <tr class="ap-table-subhead" v-else>
                                <td>You are meeting all the Evidence-based Practices in this area.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- ******************** -->
            <!-- MET Evidence-based Practices -->
            <!-- ******************** -->
            <div id="toggleMet" class="collapse content dark t2 tab-pane fade" role="tabpanel" :aria-labelledby="'un_'+selectedSection.name+'-tab'">
                <div class="has-met-pane table-responsive">
                    <div class="faux-bottom-border" style="height: 10px; background-color: #8ebb49;">&nbsp;</div>
                    <table class="table">
                        <tbody>
                            <template v-if="metGoals.length > 0">
                                <goal-option 
                                    v-for="goal in metGoals"
                                    :key="goal.id"
                                    :goal="goal"
                                    :action-plans="allActionPlans"
                                    v-on:goalSelected="createNewActionPlan"
                                ></goal-option>
                            </template>
                            <tr v-else class="ap-table-subhead">
                                <td>You are not meeting any Evidence-based Practices in this area.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
                <!-- </b-tab> -->
            <!-- </div> -->
        </div>

        <selected-goal-list
            :actionPlans="moduleActionPlans"
            v-on:removeActionPlan="removeActionPlan"
        ></selected-goal-list>

        <hr>

        <goal-selection-nav :progress="'33%'">
            <template #back>
                <a class="btn btn-orange-blue" :href="$basePath+'/action-plans/'+response.survey.slug+'/'+response.id+'/select-sections'">
                    <i class="fas fa-caret-left"></i> Go Back
                </a>
            </template>
            <template #next>
                <a class="btn btn-orange-blue" :href="$basePath+'/action-plans/'+response.survey.slug+'/'+response.id+'/start'">
                    Continue <i class="fas fa-caret-right"></i>
                </a>
            </template>
        </goal-selection-nav>

        <br />

    </div>
</template>

<script>
    import GoalOption from './goal_selection/GoalOption'
    import GoalSelectionNav from './goal_selection/GoalSelectionNav'
    import SelectedGoalList from './goal_selection/SelectedGoalList'
    import objectValues from '../../helpers/object_values.js'

    export default {
        components: {
            GoalOption,
            GoalSelectionNav,
            SelectedGoalList
        },
        props: {
            sectionResults: {
                required: true,
                type: Array
            },
            actionPlans: {
                required: true,
                type: Array
            },
            response: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                selectedSectionIdx: 0,
                selectedGoals: [],
                allActionPlans: [],
            }
        },
        computed: {
            selectedSection: function () {
                return this.sectionResults[this.selectedSectionIdx]
            },
            metGoals () {
                return Object.values(this.selectedSection.metGoals);
            },
            unmetGoals () {
                return Object.values(this.selectedSection.unmetGoals);
            },
            closeGoals() {
                return Object.keys(this.selectedSection.unmetGoals)
                        .filter(qName => {
                            const question = this.selectedSection.questions[qName]
                            return question && question.score == 3; 
                        })
                        .map(qName => this.selectedSection.unmetGoals[qName]);
            },
            notCloseGoals() {
                return Object.keys(this.selectedSection.unmetGoals).filter(qName => {
                    const question = this.selectedSection.questions[qName]
                    return question && question.score < 3; 
                })
                .map(qName => this.selectedSection.unmetGoals[qName]);
            },
            moduleActionPlans() {
                return this.allActionPlans.filter(ap => ap.goal.best_practice.module_id == this.response.survey.module_id)
            }
        },
        methods: {
            selectSection(sectionIndex) {
                this.selectedSectionIdx = sectionIndex
            },
            createNewActionPlan(goal) {
                // Using existing BAD endpoint b/c I'm running out of time -TJW
                axios.get('/action-plans/addap?goal_id='+goal.id)
                    .then(response => {
                        console.log(response)
                        this.allActionPlans.push(response.data);
                    })
                    .catch(error => {
                        alert(error);
                    })
            },
            removeActionPlan(apId) {
                
                axios.get('/action-plans/deleteap?id='+apId)
                    .then(response => {
                        let index = -1;
                        console.log(response.data)
                        this.allActionPlans.some(function(el, i) {
                            if (el.id == apId) {
                                index = i;
                                return true;
                            }
                        });
                        this.allActionPlans.splice(index, 1);
                    })
                    .catch(error => {
                        alert(error);
                    })
            },
            goalIsSelected(goal) {
                if(this.actionPlans.filter(ap => ap.goal_id == goal.id).length > 0) {
                    return true;
                }
                if (this.selectedGoals.indexOf(goal) > -1) {
                    return true;
                }
                return false;
            },
            goalInProgress(goal) {
                let actionPlan = this.actionPlans.find(ap => ap.goal_id == goal.id)
                if(actionPlan && actionPlan.start_date !== null) {
                    return true;
                }
            }     
        },
        mounted() {
            this.allActionPlans = JSON.parse(JSON.stringify(this.actionPlans));
        }
    
}
</script>